var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChainController, ConnectorController, CoreHelperUtil, OptionsController } from '@reown/appkit-core';
import { customElement } from '@reown/appkit-ui';
import { LitElement, html } from 'lit';
import { property, state } from 'lit/decorators.js';
import { ref, createRef } from 'lit/directives/ref.js';
import styles from './styles.js';
import { SnackController, RouterController, EventsController } from '@reown/appkit-core';
import { ConstantsUtil } from '@reown/appkit-common';
let W3mEmailLoginWidget = class W3mEmailLoginWidget extends LitElement {
    constructor() {
        super();
        this.unsubscribe = [];
        this.formRef = createRef();
        this.connectors = ConnectorController.state.connectors;
        this.authConnector = this.connectors.find(c => c.type === 'AUTH');
        this.email = '';
        this.loading = false;
        this.error = '';
        this.walletGuide = 'get-started';
        this.unsubscribe.push(ConnectorController.subscribeKey('connectors', val => {
            this.connectors = val;
            this.authConnector = val.find(c => c.type === 'AUTH');
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach(unsubscribe => unsubscribe());
    }
    firstUpdated() {
        this.formRef.value?.addEventListener('keydown', event => {
            if (event.key === 'Enter') {
                this.onSubmitEmail(event);
            }
        });
    }
    render() {
        const email = OptionsController.state.features?.email;
        if (!this.authConnector || !email) {
            return null;
        }
        return html `
      <form ${ref(this.formRef)} @submit=${this.onSubmitEmail.bind(this)}>
        <wui-email-input
          @focus=${this.onFocusEvent.bind(this)}
          .disabled=${this.loading}
          @inputChange=${this.onEmailInputChange.bind(this)}
          .errorMessage=${this.error}
        >
        </wui-email-input>

        ${this.submitButtonTemplate()}${this.loadingTemplate()}
        <input type="submit" hidden />
      </form>
      ${this.separatorTemplate()}
    `;
    }
    submitButtonTemplate() {
        const showSubmit = !this.loading && this.email.length > 3;
        return showSubmit
            ? html `
          <wui-icon-link
            size="sm"
            icon="chevronRight"
            iconcolor="accent-100"
            @click=${this.onSubmitEmail.bind(this)}
          >
          </wui-icon-link>
        `
            : null;
    }
    separatorTemplate() {
        const socials = OptionsController.state.features?.socials;
        const multipleConnectors = this.connectors.length > 1;
        const enableWallets = OptionsController.state.enableWallets;
        const emailShowWallets = OptionsController.state.features?.emailShowWallets;
        const hideSeparator = (socials && socials.length) || emailShowWallets || !multipleConnectors || !enableWallets;
        if (hideSeparator && this.walletGuide === 'get-started') {
            return null;
        }
        if (socials && socials.length > 0) {
            return null;
        }
        return html `
      <wui-flex
        data-testid="w3m-email-login-or-separator"
        .padding=${['xxs', '0', '0', '0']}
      >
        <wui-separator text="or"></wui-separator>
      </wui-flex>
    `;
    }
    loadingTemplate() {
        return this.loading
            ? html `<wui-loading-spinner size="md" color="accent-100"></wui-loading-spinner>`
            : null;
    }
    onEmailInputChange(event) {
        this.email = event.detail.trim();
        this.error = '';
    }
    async onSubmitEmail(event) {
        const availableChains = [ConstantsUtil.CHAIN.EVM, ConstantsUtil.CHAIN.SOLANA];
        const isAvailableChain = availableChains.find(chain => chain === ChainController.state.activeChain);
        if (!isAvailableChain) {
            RouterController.push('SwitchActiveChain', {
                switchToChain: ConstantsUtil.CHAIN.EVM
            });
            return;
        }
        try {
            if (this.loading) {
                return;
            }
            this.loading = true;
            event.preventDefault();
            const authConnector = ConnectorController.getAuthConnector();
            if (!authConnector) {
                throw new Error('w3m-email-login-widget: Auth connector not found');
            }
            const { action } = await authConnector.provider.connectEmail({ email: this.email });
            EventsController.sendEvent({ type: 'track', event: 'EMAIL_SUBMITTED' });
            if (action === 'VERIFY_OTP') {
                EventsController.sendEvent({ type: 'track', event: 'EMAIL_VERIFICATION_CODE_SENT' });
                RouterController.push('EmailVerifyOtp', { email: this.email });
            }
            else if (action === 'VERIFY_DEVICE') {
                RouterController.push('EmailVerifyDevice', { email: this.email });
            }
        }
        catch (error) {
            const parsedError = CoreHelperUtil.parseError(error);
            if (parsedError?.includes('Invalid email')) {
                this.error = 'Invalid email. Try again.';
            }
            else {
                SnackController.showError(error);
            }
        }
        finally {
            this.loading = false;
        }
    }
    onFocusEvent() {
        EventsController.sendEvent({ type: 'track', event: 'EMAIL_LOGIN_SELECTED' });
    }
};
W3mEmailLoginWidget.styles = styles;
__decorate([
    state()
], W3mEmailLoginWidget.prototype, "connectors", void 0);
__decorate([
    state()
], W3mEmailLoginWidget.prototype, "authConnector", void 0);
__decorate([
    state()
], W3mEmailLoginWidget.prototype, "email", void 0);
__decorate([
    state()
], W3mEmailLoginWidget.prototype, "loading", void 0);
__decorate([
    state()
], W3mEmailLoginWidget.prototype, "error", void 0);
__decorate([
    property()
], W3mEmailLoginWidget.prototype, "walletGuide", void 0);
W3mEmailLoginWidget = __decorate([
    customElement('w3m-email-login-widget')
], W3mEmailLoginWidget);
export { W3mEmailLoginWidget };
//# sourceMappingURL=index.js.map